export const socialMedia = [
  {
    id: 1,
    hrefLink: "#",
    faIcon: "fa-brands fa-square-facebook",
    name: "Facebook",
  },
  {
    id: 2,
    hrefLink: "#",
    faIcon: "fa-brands fa-instagram",
    name: "Instagram",
  },
  {
    id: 3,
    hrefLink: "#",
    faIcon: "fa-brands fa-twitter",
    name: "Twitter",
  },
  {
    id: 4,
    hrefLink: "#",
    faIcon: "fa-brands fa-linkedin",
    name: "LinkedIn",
  },
];

export const mainNav = [
  {
    id: 1,
    linkTo: "/",
    linkName: "Home",
  },
  {
    id: 2,
    linkTo: "/About",
    linkName: "About",
  },
  {
    id: 3,
    linkTo: "/OurServices",
    linkName: "Our Services",
  },
  {
    id: 4,
    linkTo: "/TrainingAndCoaching",
    linkName: "Training & Coaching",
  },
  {
    id: 5,
    linkTo: "/FAQs",
    linkName: "FAQs",
  },
  {
    id: 6,
    linkTo: "/Contact",
    linkName: "Contact",
  },
];
